var _style, _g, _g2, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgcontent",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.xConnector-st0{fill:#FFFFFF;stroke:currentColor;stroke-width:1;stroke-miterlimit:29.9994;}\r\n\t.xConnector-st1{stroke:currentColor;stroke-miterlimit:30;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "svg_2_00000007404549551122340690000006812353583101558688_",
    x: 39.8,
    y: 33,
    className: "xConnector-st0",
    width: 36.7,
    height: 13.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_2_00000009563465833967593380000003779082357657482907_",
    x: 32.9,
    y: 2.9,
    className: "xConnector-st0",
    width: 13.8,
    height: 36.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "svg_2_00000069384606838632945310000002476726080262379439_",
    x: 3.1,
    y: 33,
    className: "xConnector-st0",
    width: 36.7,
    height: 13.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_2_00000066479996499358345860000002786936403885289899_",
    x: 32.9,
    y: 40.3,
    className: "xConnector-st0",
    width: 13.8,
    height: 36.7
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_3",
    className: "xConnector-st1",
    cx: 39.6,
    cy: 39.9,
    rx: 10.3,
    ry: 10.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXConnector);
export default __webpack_public_path__ + "static/media/xConnector.2d162a4acbb56602188a9f74a223177b.svg";
export { ForwardRef as ReactComponent };